import Vue from 'vue'

Vue.mixin({
  data() {
    return {
      rowActions: []
    }
  },
  mounted() {
    window.vibrate = this.vibrate
  },
  methods: {
    scrollSiblingUl(e, diff, selector) {
      if (e) {
        e.stopPropagation()
        e.preventDefault()
      }
      this.vibrate(e)
      $(selector).animate(
        {
          scrollLeft: $(selector).scrollLeft() + diff + 'px'
        },
        'ease-in'
      )
    },
    clearCache(e) {
      if (e) {
        e.stopPropagation()
        e.preventDefault()
      }
      localStorage.removeItem('savedConfigs')
      localStorage.removeItem('savedStrings')
      if (window.device && window.device.clearCache) {
        window.device.clearCache()
      } else if (window.app && window.app.reload) {
        window.app.reload()
      } else {
        window.location.reload(true)
      }
    },
    onEnter(e, handler) {
      if (e.keyCode === 13) {
        setTimeout(() => {
          this.$forceUpdate()
          this.$nextTick(() => {
            handler(e)
          })
        }, 50)
      }
    },
    showDeniedMenuForTicketUser() {
      if (window.showAlertModal) {
        window.showAlertModal(
          this.$t('menu.alert.title.access_denied'),
          this.$t('ticket.notification.denied_menu')
        )
      } else {
        alert(this.$t('ticket.notification.denied_menu'))
      }
    },
    setResetAlarms(resets) {
      if (window.app && window.app.clearAllAlarms) {
        window.app.clearAllAlarms()
      }
      if (!resets || resets.length === 0) {
        return
      }
      const scheduleAlarms = {}
      for (let i = 0; i < resets.length; i++) {
        const reset = resets[i]
        for (let j = 0; j < reset.schedules.length; j++) {
          const sched = reset.schedules[j]
          this.setResetAlarm(reset, sched, 'morning', scheduleAlarms)
          this.setResetAlarm(reset, sched, 'noon', scheduleAlarms)
          this.setResetAlarm(reset, sched, 'night', scheduleAlarms)
        }
      }
    },
    getResetPrice(reset) {
      let amount = 0
      if (reset && reset.products) {
        for (let i = 0; i < reset.products.length; i++) {
          const productAmount = reset.products[i].co * reset.products[i].pc
          amount += productAmount
        }
      }
      if (amount < 10000) {
        return this.$options.filters.formatNumber(amount)
      }
      return (
        this.$options.filters.formatNumber(Math.round(amount / 10000)) + '만'
      )
    },
    getTotalDateCount(reset) {
      if (!reset) {
        return 0
      }
      const bgnde = reset.bgnde.split('/')
      const endde = reset.endde.split('/')
      const bgndeDate = new Date(
        parseInt(bgnde[0]),
        parseInt(bgnde[1]) - 1,
        parseInt(bgnde[2])
      )
      const enddeDate = new Date(
        parseInt(endde[0]),
        parseInt(endde[1]) - 1,
        parseInt(endde[2])
      )
      const diff = Math.floor(
        (enddeDate.getTime() - bgndeDate.getTime()) / 86400000
      )
      return diff + 1
    },
    setResetAlarm(reset, sched, time, scheduleAlarms) {
      let timePrefix = time
      if (time === 'morning') {
        timePrefix = 'morn'
      }
      if (reset[timePrefix + 'NtcnFlag'] === 'N') {
        return
      }

      if (
        sched[time] &&
        sched[time].length > 0 &&
        !scheduleAlarms[reset.id + '-' + sched.de + '-' + time]
      ) {
        scheduleAlarms[reset.id + '-' + sched.de + '-' + time] = true
        let id = 0
        for (let k = 0; k < sched[time].length; k++) {
          const detail = sched[time][k]
          if (id === 0 || detail.id < id) {
            id = detail.id
          }
        }
        if (window.app && window.app.setAlarm) {
          const params = {
            name: reset.nm,
            date: sched.de,
            time: this.$t('reset.text.' + time)
          }
          let contents = this.$t('reset.notification.contents', params)
          if (!this.quotes) {
            this.quotes = []
            const locale = this.$store.state.locale
            const messages = this.$store.state.messages
            for (const key in messages[locale]) {
              const charst = messages[locale][key]
              if (key.indexOf('quote.item.') === 0) {
                this.quotes.push(charst)
              }
            }
          }
          if (this.quotes && this.quotes.length > 0) {
            const rand = Math.floor(Math.random() * 10000) % this.quotes.length
            contents = this.quotes[rand]
          }
          const extras = {
            title: this.$t('reset.alarm.' + time + '_notice'),
            contents: contents,
            notificationId: '' + id,
            channelId: 'default',
            channelName: this.$t('reset.notification.channel_name'),
            channelDescription: this.$t(
              'reset.notification.channel_description'
            ),
            info: this.$t('reset.notification.info')
          }
          window.app.setAlarm(
            '' + id,
            sched.de,
            reset[timePrefix + 'NtcnTm'],
            JSON.stringify(extras)
          )
          const ymd = sched.de.split('/')
          const tm = reset[timePrefix + 'NtcnTm'].split(':')
          const dt = new Date(ymd[0], ymd[1] - 1, ymd[2], tm[0], tm[1])
          dt.setMinutes(dt.getMinutes() - 10)
          let contents10 = this.$t('reset.notification.contents', params)
          if (this.quotes && this.quotes.length > 0) {
            const rand = Math.floor(Math.random() * 10000) % this.quotes.length
            contents10 = this.quotes[rand]
          }
          const extras10 = {
            title: this.$t('reset.alarm.' + time + '_10_minute_notice'),
            contents: contents10,
            notificationId: '-' + id,
            channelId: 'default',
            channelName: this.$t('reset.notification.channel_name'),
            channelDescription: this.$t(
              'reset.notification.channel_description'
            ),
            info: this.$t('reset.notification.info')
          }
          let dateStr = dt.getFullYear() + '/'
          if (dt.getMonth() + 1 < 10) {
            dateStr += '0'
          }
          const month = dt.getMonth() + 1
          dateStr += month + '/'
          if (dt.getDate() < 10) {
            dateStr += '0'
          }
          dateStr += dt.getDate()
          let timeStr = ''
          if (dt.getHours() < 10) {
            timeStr += '0'
          }
          timeStr += dt.getHours() + ':'
          if (dt.getMinutes() < 10) {
            timeStr += '0'
          }
          timeStr += dt.getMinutes()
          window.app.setAlarm(
            '' + id,
            dateStr,
            timeStr,
            JSON.stringify(extras10)
          )
        }
      }
    },
    logSize(data, parentKey) {
      for (const key in data) {
        if (!data[key]) {
          continue
        }
        let fullKey = ''
        if (parentKey) {
          fullKey = parentKey
        }
        fullKey += '.' + key
        console.log(fullKey + ' ' + JSON.stringify(data[key]).length)
        if (typeof data[key] === 'object') {
          this.logSize(data[key], fullKey)
        }
      }
    },
    resize: function(dataURL, maxSize, callback) {
      const image = new Image()
      image.onload = () => {
        // Resize image
        const canvas = document.createElement('canvas')
        let height = image.height
        const width = maxSize
        height = (image.height * maxSize) / image.width
        canvas.width = width
        canvas.height = height
        const ctx = canvas.getContext('2d')
        ctx.drawImage(image, 0, 0, width, height)
        const canvasData = ctx.getImageData(0, 0, width, height)
        for (let i = 0; i < width; i++) {
          for (let j = 0; j < height; j++) {
            if (this.getPixel(canvasData, width, i, j) > 50) {
              this.drawPixel(canvasData, width, i, j, 255, 255, 255, 255)
            }
          }
        }
        ctx.putImageData(canvasData, 0, 0)
        callback(canvas.toDataURL('image/png', 0.8))
      }
      image.src = dataURL
    },
    onFocusNumberInput(e) {
      if (!e.target.value || e.target.value === '0') {
        setTimeout(() => {
          e.target.value = ''
        }, 100)
      }
    },
    onBlurNumberInput(e) {
      if (!e.target.value) {
        e.target.value = 0
      }
    },
    recognize(file, cb) {
      if (!file) {
        return
      }
      const reader = new FileReader()
      this.ocrResult = '판독 중..'

      reader.onload = () => {
        this.ocrPreviewImage = reader.result
        this.resize(reader.result, 200, blob => {
          this.ocrPreviewImage2 = blob
          try {
            const worker = this.$tesseract.createWorker()
            ;(async () => {
              await worker.load()
              await worker.loadLanguage('kor')
              await worker.initialize('kor')
              await worker.setParameters(this.params)
              const {
                data: { text }
              } = await worker.recognize(blob)

              let escapedText = text
              if (escapedText) {
                escapedText = escapedText.escapeHtml()
              }
              this.ocrResult = ''
              const numbers = escapedText.split('\n')
              if (cb) {
                cb(numbers)
              }
              await worker.terminate()
            })()
          } catch (e) {
            this.ocrResult = e
          }
        })
      }
      reader.onerror = function(error) {
        this.ocrResult = '파일 읽기 오류..'
        console.log('Error: ', error)
      }
      reader.readAsDataURL(file)
    },
    drawPixel(canvasData, width, x, y, r, g, b, a) {
      const index = (x + y * width) * 4
      canvasData.data[index] = r
      canvasData.data[index + 1] = g
      canvasData.data[index + 2] = b
      canvasData.data[index + 3] = a
    },
    getPixel(canvasData, width, x, y) {
      const index = (x + y * width) * 4
      const r = canvasData.data[index]
      const g = canvasData.data[index + 1]
      const b = canvasData.data[index + 2]
      const ret = (r + g + b) / 3
      return ret
    },
    goBack(e) {
      if ($('body').attr('path') === '/') {
        return
      }
      this.vibrate(e)
      history.back()
    },
    vibrate(e) {
      if (e && e.vibrated) {
        return
      }
      if (window.device && window.device.vibrate) {
        window.device.vibrate(50, 10)
      } else {
        console.log('vibrate')
      }
      if (e) {
        e.vibrated = true
      }
    },
    getDeviceInfo() {
      return window.getDeviceInfo()
    },
    getDeviceId() {
      return window.getDeviceId()
    },
    getCurrentUrl() {
      return window.location.href
    },
    openURL(url, target) {
      if (url) {
        if (url.startsWith('unistars:/')) {
          url = url.substring('unistars:/'.length)
        }
        if (url.startsWith('/') || url.indexOf('app.unistars.kr') >= 0) {
          this.openLink(url)
        } else {
          if (!target) {
            if (url.startsWith('http:') || url.startsWith('https:')) {
              target = '_blank'
            } else {
              target = '_self'
            }
          }
          if (window.app && window.app.openBrowser) {
            window.app.openBrowser(url)
          } else {
            window.open(url, target)
          }
        }
      }
    },
    async validateUnder(elem, scrollElem, onBeginCb, onSuccessCb, onFailCb) {
      if (onBeginCb) {
        onBeginCb()
      }
      let invalidInputControlName
      const inputControlNames = []
      $(elem)
        .find('[input-control-name]')
        .each(function() {
          if (!$(this).attr('readonly') && !$(this).attr('disabled')) {
            inputControlNames.push($(this).attr('input-control-name'))
          }
        })
      for (let i = 0; i < inputControlNames.length; i++) {
        if (!(await this.$validator.validate(inputControlNames[i]))) {
          invalidInputControlName =
            '[input-control-name="' + inputControlNames[i] + '"]'
          break
        }
      }
      if (invalidInputControlName) {
        if (onFailCb) {
          onFailCb(invalidInputControlName)
        }
        this.$nextTick(() => {
          let relative = 0
          if (!scrollElem) {
            scrollElem = 'html'
          } else {
            relative = $(scrollElem).scrollTop() + $(scrollElem).offset().top
          }
          $(scrollElem).animate(
            {
              scrollTop:
                $(invalidInputControlName).offset().top + relative - 150
            },
            400,
            'swing',
            () => {
              $(invalidInputControlName).animate(
                {
                  opacity: 0.4
                },
                200,
                'swing',
                () => {
                  $(invalidInputControlName).animate(
                    {
                      opacity: 1
                    },
                    200,
                    'swing'
                  )
                }
              )
            }
          )
          this.$toast.error(
            $(invalidInputControlName)
              .find('.show-invalid')
              .first()
              .text()
          )
          $(invalidInputControlName)
            .find('input[type!=hidden]')
            .focus()
        })
      } else if (onSuccessCb) {
        onSuccessCb()
      }
      return invalidInputControlName === undefined
    },
    async openMenuPathWithAditFieldData(keyString, value, obj) {
      const url = await this.getMenuPathWithAditFieldData(keyString, value, obj)
      if (!url) {
        this.$toast.error(this.$t('page.error.not_found'))
        return
      }
      window.open(url)
    },
    async getMenuPathWithAditFieldData(keyString, value, obj) {
      const res = await this.$axios.$get(
        '/menu/public/getMenuPathWithAditFieldData?keyString=' +
          encodeURIComponent(keyString) +
          '&value=' +
          encodeURIComponent(value),
        {
          no_loading: true
        }
      )
      if (obj && res.data) {
        obj.menuPath = res.data
      }
      return res.data
    },
    getPrefix(inputControl, object) {
      let prefix = ''
      if (
        inputControl &&
        inputControl.valueSource &&
        inputControl.valueSource.prefixes
      ) {
        for (let i = 0; i < inputControl.valueSource.prefixes.length; i++) {
          const prefixValueSource = inputControl.valueSource.prefixes[i]
          prefix += this.getValueSourceValue(prefixValueSource, object)
        }
      }
      return prefix
    },
    getPostfix(inputControl, object) {
      let postfix = ''
      if (
        inputControl &&
        inputControl.valueSource &&
        inputControl.valueSource.postfixes
      ) {
        for (let i = 0; i < inputControl.valueSource.postfixes.length; i++) {
          const postfixValueSource = inputControl.valueSource.postfixes[i]
          postfix += this.getValueSourceValue(postfixValueSource, object)
        }
      }
      return postfix
    },
    getWithFields(inputControl) {
      const fields = []
      for (const key in inputControl.rules) {
        if (
          inputControl.rules[key].withFields &&
          inputControl.rules[key].withFields.length > 0
        ) {
          for (let i = 0; i < inputControl.rules[key].withFields.length; i++) {
            if (inputControl.rules[key].withFields[i].fieldName) {
              fields.push(inputControl.rules[key].withFields[i].fieldName)
            } else if (inputControl.rules[key].withFields[i].value) {
              fields.push(inputControl.rules[key].withFields[i].value)
            }
          }
        }
      }
      return fields
    },
    getValueSourceValue(valueSource, object) {
      const type = valueSource.type
      let value = ''
      if (valueSource.prefixes && valueSource.prefixes.length > 0) {
        for (let i = 0; i < valueSource.prefixes.length; i++) {
          value += this.getValueSourceValue(valueSource.prefixes[i], object)
        }
      }
      switch (type) {
        case 'static_value':
          value += valueSource.staticValue
          break
        case 'other_column':
          const keys = valueSource.fieldName.split('.')
          let val = window.copyObject(object)

          for (let j = 0; j < keys.length; j++) {
            val = val[keys[j]]
            if (val === undefined || val === null) {
              return ''
            }
          }
          value += val
          break
      }
      if (valueSource.postfixes && valueSource.postfixes.length > 0) {
        for (let i = 0; i < valueSource.postfixes.length; i++) {
          value += this.getValueSourceValue(valueSource.postfixes[i], object)
        }
      }
      return value
    },
    async checkCodes(codeId) {
      if (!this.codes) {
        this.codes = {}
      }
      if (!codeId) {
        return
      }
      const codeGroupId = codeId.split('.')[0]
      if (!this.codes[codeGroupId]) {
        this.codes[codeGroupId] = {}
        const codes = await this.getCodes(codeGroupId)
        for (let i = 0; i < codes.length; i++) {
          this.codes[codeGroupId][codes[i].codeId] = codes[i]
        }
      }
    },
    openBrowser(url) {
      if (!url) {
        return
      }
      if (window.app && window.app.openBrowser) {
        window.app.openBrowser(url)
      } else {
        window.open(url, '_blank')
      }
    },
    async getCodeAttr1(codeId) {
      await this.checkCodes(codeId)
      const codeGroupId = codeId.split('.')[0]
      return this.codes[codeGroupId][codeId].codeAttr1
    },
    async getCodeAttr2(codeId) {
      await this.checkCodes(codeId)
      const codeGroupId = codeId.split('.')[0]
      return this.codes[codeGroupId][codeId].codeAttr2
    },
    async getCodeAttr3(codeId) {
      await this.checkCodes(codeId)
      const codeGroupId = codeId.split('.')[0]
      return this.codes[codeGroupId][codeId].codeAttr3
    },
    async getCodeAttr4(codeId) {
      await this.checkCodes(codeId)
      if (!codeId) {
        return
      }
      const codeGroupId = codeId.split('.')[0]
      if (
        !codeGroupId ||
        !this.codes[codeGroupId] ||
        !this.codes[codeGroupId][codeId]
      ) {
        return
      }
      return this.codes[codeGroupId][codeId].codeAttr4
    },
    async getCodes(codeGroupId, excludes) {
      let url = '/code/public/codes?codeGroup=' + codeGroupId
      let excludesString = ''
      if (excludes && excludes.length > 0) {
        for (let i = 0; i < excludes.length; i++) {
          if (excludesString) {
            excludesString += ','
          }
          excludesString += excludes[i]
        }
      }
      if (excludesString) {
        url += '&excludes=' + excludesString
      }
      const res = await this.$axios.$get(url, {
        no_loading: true
      })
      return res.data
    },
    copyToClipboard(val) {
      const t = document.createElement('textarea')
      document.body.appendChild(t)
      t.value = val
      t.select()
      document.execCommand('copy')
      document.body.removeChild(t)
    },
    getCharstCode(valueSource, data) {
      if (typeof valueSource === 'string') {
        return valueSource
      }
      let textCode = ''
      if (valueSource.codePrefixes && valueSource.codePrefixes.length > 0) {
        for (let m = 0; m < valueSource.codePrefixes.length; m++) {
          const codePrefix = valueSource.codePrefixes[m]
          textCode += this.getValueSourceValue(codePrefix, data)
        }
      }
      if (valueSource.type === 'static_value') {
        textCode += valueSource.staticValue
      } else if (valueSource.type === 'other_column') {
        const keys = valueSource.fieldName.split('.')
        let val = data
        for (let j = 0; j < keys.length; j++) {
          val = val[keys[j]]
          if (val === undefined) {
            return ''
          }
        }
        textCode += val
      }
      if (valueSource.codePostfixes && valueSource.codePostfixes.length > 0) {
        for (let m = 0; m < valueSource.codePostfixes.length; m++) {
          const codePostfix = valueSource.codePostfixes[m]
          textCode += this.getValueSourceValue(codePostfix, data)
        }
      }
      return textCode
    },
    isListVisibleColumn(column) {
      const visibleType = column.list.visibleType
      if (visibleType === 'none') {
        return false
      }
      if (visibleType === 'simple') {
        const visibleBy = column.list.visibleBy
        if (visibleBy) {
          for (let i = 0; i < visibleBy.length; i++) {
            if (visibleBy[i].type === 'master_data') {
              if (!this.masterSelectedRow) {
                return false
              }
              const key = visibleBy[i].fieldName + '_original_data'
              const val = this.masterSelectedRow[key]
              for (let k = 0; k < visibleBy[i].in.length; k++) {
                if (val === visibleBy[i].in[k]) {
                  return true
                }
              }
              return false
            } else {
              console.error(
                'Unsupported visible-by type for list : ' + visibleBy[i].type
              )
              return false
            }
          }
        }
      }
      return true
    },
    isNotEmpty(obj) {
      return !this.isEmpty(obj)
    },
    isEmpty(obj) {
      return obj === undefined || obj === null || obj === ''
    },
    isAvailableRowAction(action) {
      if (this.rowActions) {
        return this.rowActions.indexOf(action) >= 0
      }
      return false
    },
    loadUpdate(userUpdate) {
      this.userUpdateRow = userUpdate.contents
      this.updateColumns = window.copyObject(userUpdate.columns)
      this.makeLabels(this.updateColumns)

      // 다국어 아직 로딩되지 않은 문자열은 store에 저장
      if (userUpdate && userUpdate.infos && userUpdate.infos.charsts) {
        for (let i = 0; i < userUpdate.infos.charsts.length; i++) {
          this.setI18nMessage(
            userUpdate.infos.charsts[i].locale.locale,
            userUpdate.infos.charsts[i].code,
            userUpdate.infos.charsts[i].charst
          )
        }
      }
      if (this.infos.additionalFieldInfoData) {
        this.initAdditionalFieldData(
          this.userUpdateRow,
          this.infos.additionalFieldInfoData
        )
      }
      if (this.infos.additionalFieldInfoSampleData) {
        this.initAdditionalFieldSampleData(
          this.userUpdateRow,
          this.infos.additionalFieldInfoSampleData
        )
      }
      this.userUpdateRow = this.updateUpdateColumns(
        this.userUpdateRow,
        this.updateColumns,
        userUpdate.infos
      )
      this.initialUpdateRow = window.copyObject(this.userUpdateRow)
    },
    initInsertRow(columns) {
      const row = {}
      for (let i = 0; i < columns.length; i++) {
        const key = columns[i].key
        const column = columns[i]
        if (!column.inputControl) {
          column.inputControl = {
            type: 'none'
          }
        }
        if (column.inputControl.type === 'i18n') {
          const charsts = []
          for (let i = 0; i < this.$store.state.locales.length; i++) {
            const locale = this.$store.state.locales[i]
            charsts.push({ charst: '', locale: { locale: locale.value } })
          }
          row[column.key] = charsts
        }
        if (column.inputControl.initialValue) {
          row[key] = column.inputControl.initialValue
        } else if (column.inputControl.type === 'select') {
          row[key] = ''
        }
        if (
          this.insertColumns[i].list &&
          this.insertColumns[i].list.treeNodeTitle
        ) {
          row[key] = 'common.text.new_item'
        }
        if (column.inputControl.type === 'section') {
          row[key] = []
          row[key].push(this.initInsertRow(column.columns))
        }
      }

      if (this.infos.additionalFieldInfo) {
        row.additionalFieldInfos = []
      }

      if (this.infos.additionalFieldInfoData) {
        this.initAdditionalFieldData(row, this.infos.additionalFieldInfoData)
      }
      if (this.infos.additionalFieldInfoSampleData) {
        this.initAdditionalFieldSampleData(
          row,
          this.infos.additionalFieldInfoSampleData
        )
      }

      if (this.slaveEvent) {
        for (let i = 0; i < this.totalColumns.length; i++) {
          const column = this.totalColumns[i]
          if (column.common && column.common.masterKey) {
            row[column.key] = this.masterSelectedRow
          }
        }
      }
      return row
    },
    updateUpdateColumns(row, columns, infos) {
      if (columns.length > 0) {
        for (let i = columns.length - 1; i >= 0; i--) {
          if (!columns[i].update) {
            columns.splice(i, 1)
            continue
          }
          const key = columns[i].key
          if (!columns[i].common || !columns[i].common.label) {
            columns[i].label = this.getDefaultColumnNameCode(key.toSnakeCase())
          } else {
            columns[i].label = columns[i].common.label
          }
          columns[i].label = this.$t(columns[i].label)
          const prefix = this.getPrefix(columns[i].inputControl, row)
          if (prefix && row[key]) {
            row[key] = row[key].substring(prefix.length)
          }
          const postfix = this.getPostfix(columns[i].inputControl, row)
          if (postfix && row[key]) {
            row[key] = row[key].substring(0, row[key].length - postfix.length)
          }
          if (columns[i].inputControl.type === 'map' && row[key]) {
            row[key] = JSON.parse(row[key])
          } else if (columns[i].inputControl.type === 'i18n') {
            row[key] = infos.charsts[key]
          } else if (columns[i].inputControl.type === 'multiselect_list') {
            const values = []
            if (columns[i].inputControl.candidate) {
              const candidateKey = columns[i].inputControl.candidate.key
              if (candidateKey) {
                for (let j = 0; j < row[key].length; j++) {
                  values.push(row[key][j][candidateKey])
                }
              }
            }
            row[key] = values
          } else if (columns[i].inputControl.type === 'select') {
            if (!row[key]) {
              row[key] = ''
            } else if (
              columns[i].inputControl.candidate &&
              columns[i].inputControl.candidate.key &&
              typeof row[key] === 'object'
            ) {
              const candidateKey = columns[i].inputControl.candidate.key
              if (candidateKey) {
                row[key] = row[key][candidateKey]
              }
            }
          } else if (columns[i].inputControl.type === 'multiselect') {
            const values = []
            if (columns[i].inputControl.candidate) {
              const candidateKey = columns[i].inputControl.candidate.key
              const candidateInfo = columns[i].inputControl.candidate

              if (candidateKey) {
                if (Array.isArray(row[key])) {
                  for (let j = 0; j < row[key].length; j++) {
                    const value = row[key][j][candidateKey]

                    let label = ''
                    let optionData
                    if (columns[i].inputControl.candidate.options) {
                      for (
                        let k = 0;
                        k < columns[i].inputControl.candidate.options.length;
                        k++
                      ) {
                        if (value === candidateInfo.options[k].value) {
                          label = this.makeOptionText(candidateInfo.options[k])
                          optionData = candidateInfo.options[k].data
                          break
                        }
                      }
                    }
                    values.push({
                      value: value,
                      text: label,
                      data: optionData
                    })
                  }
                } else if (row[key]) {
                  const value = row[key][candidateKey]
                  let label = ''
                  let optionData
                  if (columns[i].inputControl.candidate.options) {
                    for (
                      let k = 0;
                      k < columns[i].inputControl.candidate.options.length;
                      k++
                    ) {
                      if (value === candidateInfo.options[k].value) {
                        label = this.makeOptionText(candidateInfo.options[k])
                        optionData = candidateInfo.options[k].data
                        break
                      }
                    }
                  } else {
                    if (columns[i].common && columns[i].common.textInfos) {
                      label = this.getTextFromTextInfos(
                        columns[i].common.textInfos,
                        row,
                        key,
                        columns[i].common.separatorTextInfos,
                        columns[i].common.targetType,
                        columns[i].common.noDataLabelTextCode
                      ).stripTags()
                    } else {
                      label = row[key]
                    }

                    optionData = row[key]
                  }
                  values.push({
                    value: value,
                    text: label,
                    data: optionData
                  })
                }
              }
            }
            row[key] = values
          }

          if (
            columns[i].inputControl &&
            columns[i].inputControl.type === 'section'
          ) {
            if (!row[key]) {
              row[key] = [{}]
            }
            if (row[key].length === 0) {
              row[key].push(this.initInsertRow(columns[i].columns))
            }
          } else if (
            columns[i].inputControl &&
            columns[i].inputControl.type === 'section_list'
          ) {
            if (!row[key]) {
              row[key] = []
            }
          }
          if (columns[i].columns) {
            for (let j = 0; j < row[key].length; j++) {
              row[key][j] = this.updateUpdateColumns(
                row[key][j],
                columns[i].columns,
                infos
              )
            }
          }
        }
      }
      return row
    },
    getTextFromTextInfos(
      textInfos,
      item,
      key,
      separator,
      targetType,
      noDataLabelTextCode
    ) {
      let fieldValue

      if (textInfos[0].field) {
        fieldValue = item[textInfos[0].field]
      } else {
        fieldValue = item[key]
      }
      let text = ''
      if (Array.isArray(fieldValue)) {
        for (let i = 0; i < fieldValue.length; i++) {
          if (text) {
            text += ', '
          }
          text += this.getOneTextFromTextInfos(
            textInfos,
            fieldValue[i],
            item,
            separator,
            targetType,
            noDataLabelTextCode
          )
        }
      } else {
        text += this.getOneTextFromTextInfos(
          textInfos,
          fieldValue,
          item,
          separator,
          targetType,
          noDataLabelTextCode
        )
      }

      return text
    },
    getOneTextFromTextInfos(
      textInfos,
      item,
      parentItem,
      separator,
      targetType,
      noDataLabelTextCode
    ) {
      const texts = []
      for (let k = 0; k < textInfos.length; k++) {
        const textInfo = textInfos[k]

        let textTemp = ''
        let fieldValue = window.copyObject(item)

        const fieldInField = textInfo.fieldInField
        if (fieldInField) {
          const hierarchicalKeys = fieldInField.split('.')
          for (let m = 0; m < hierarchicalKeys.length; m++) {
            if (fieldValue) {
              fieldValue = fieldValue[hierarchicalKeys[m]]
            }
          }
        }

        if (fieldValue) {
          if (textInfo.textPrefixes && textInfo.textPrefixes.length > 0) {
            for (let m = 0; m < textInfo.textPrefixes.length; m++) {
              textTemp += textInfo.textPrefixes[m]
            }
          }

          let textCode = ''
          if (textInfo.codePrefixes && textInfo.codePrefixes.length > 0) {
            for (let m = 0; m < textInfo.codePrefixes.length; m++) {
              const codePrefix = textInfo.codePrefixes[m]
              textCode += this.getValueSourceValue(codePrefix, parentItem)
            }
          }
          textCode += fieldValue
          if (textInfo.codePostfixes && textInfo.codePostfixes.length > 0) {
            for (let m = 0; m < textInfo.codePostfixes.length; m++) {
              const codePostfix = textInfo.codePostfixes[m]
              textCode += this.getValueSourceValue(codePostfix, parentItem)
            }
          }
          if (textInfo.multilanguage) {
            textTemp += this.$t(textCode)
          } else {
            textTemp += textCode
          }

          if (textInfo.textPostfixes && textInfo.textPostfixes.length > 0) {
            for (let m = 0; m < textInfo.textPostfixes.length; m++) {
              textTemp += textInfo.textPostfixes[m]
            }
          }
          if (
            targetType === 'User' &&
            item &&
            item.sttusCode === 'user_status.secession' &&
            textInfos.length === k + 1
          ) {
            textTemp += ' - ' + this.$t('common.text.secession_user')
          }
        } else if (noDataLabelTextCode) {
          textTemp = this.$t(noDataLabelTextCode)
        } else if (targetType === 'User') {
          textTemp = this.$t('common.text.deleted_user')
        }
        texts.push(textTemp)
      }
      let text = ''
      for (const key in texts) {
        if (text) {
          text += separator
        }
        if (texts[key]) {
          text += texts[key].escapeHtml()
        }
      }
      return text
    },
    getContents(item, key) {
      let value = item

      if (key) {
        const keys = key.split('.')

        for (let i = 0; i < keys.length; i++) {
          if (value) {
            value = value[keys[i]]
          }
        }
      }
      return value
    },
    getNotifications(inputControl, created) {
      let notifications = inputControl.notifications
      if (!notifications) {
        notifications = []
      }
      if (created) {
        if (inputControl.insertNotifications) {
          notifications = notifications.concat(inputControl.insertNotifications)
        }
      } else if (inputControl.updateNotifications) {
        notifications = notifications.concat(inputControl.updateNotifications)
      }
      return notifications
    },
    isVisibleControl() {
      return this.isVisibleData(
        this.visibleData,
        this.visibleBy,
        this.visibleType
      )
    },
    isVisibleData(row, visibleBys, visibleType) {
      if (visibleType === 'simple') {
        if (visibleBys && row) {
          for (let i = 0; i < visibleBys.length; i++) {
            if (!this.isVisibleDatum(row, visibleBys[i])) {
              return false
            }
          }
          return true
        }
        return false
      }
      return true
    },
    isVisibleDatum(row, visibleBy) {
      if (visibleBy.type === 'master_data') {
        if (!this.masterSelectedRow) {
          return false
        }
        const key = visibleBy.fieldName + '_original_data'
        const val = this.masterSelectedRow[key]
        for (let k = 0; k < visibleBy.in.length; k++) {
          if (val === visibleBy.in[k]) {
            return true
          }
        }
        return false
      } else if (visibleBy.type === 'depth') {
        if (visibleBy.depth && visibleBy.depth === this.nodeDepth) {
          return true
        }
        return false
      } else if (visibleBy.type === 'other_column') {
        // 다른 컬럼을 참조해서 보이기/안보이기 체크
        const keys = visibleBy.fieldName.split('.')
        let val = row
        val = val[keys[0]]

        if (val) {
          if (Array.isArray(val)) {
            if (keys.length > 1) {
              keys.splice(0, 1)
            }
            if (visibleBy.isEmpty) {
              if (val.length === 0) {
                return true
              } else {
                return false
              }
            }
            const options = window.copyObject(val)

            for (let j = 0; j < options.length; j++) {
              if (options[j].data) {
                val = options[j].data
              } else {
                val = options[j]
              }
              if (!val) {
                return false
              }
              for (let k = 0; k < keys.length; k++) {
                val = val[keys[k]]
                if (!val) {
                  return false
                }
              }
              for (let k = 0; k < visibleBy.in.length; k++) {
                if (val === visibleBy.in[k]) {
                  return true
                }
              }
              if (visibleBy.notIn && visibleBy.notIn.length > 0) {
                for (let k = 0; k < visibleBy.notIn.length; k++) {
                  if (val === visibleBy.notIn[k]) {
                    return false
                  }
                }
                return true
              }
            }
          } else {
            val = row
            for (let j = 0; j < keys.length; j++) {
              if (val) {
                val = val[keys[j]]
              }
              if (j === 0 && val.data) {
                val = val.data
              }
            }
            for (let j = 0; j < visibleBy.in.length; j++) {
              if (val === visibleBy.in[j]) {
                return true
              }
            }
            if (visibleBy.notIn && visibleBy.notIn.length > 0) {
              for (let j = 0; j < visibleBy.notIn.length; j++) {
                if (val === visibleBy.notIn[j]) {
                  return false
                }
              }
              return true
            }
          }
          return false
        } else if (visibleBy.isEmpty) {
          return true
        } else {
          return false
        }
      }
      return false
    },
    cssClasses(cssClassesObj, additionalClasses) {
      let classes = ''
      if (additionalClasses) {
        classes = additionalClasses
      }
      if (
        cssClassesObj &&
        cssClassesObj.cssClasses &&
        cssClassesObj.cssClasses.length > 0
      ) {
        for (let i = 0; i < cssClassesObj.cssClasses.length; i++) {
          if (classes) {
            classes += ' '
          }
          classes += cssClassesObj.cssClasses[i]
        }
      }
      return classes
    },
    emitForceUpdate() {
      this.$emit('forceUpdate')
    },
    onForceUpdate() {
      this.$forceUpdate()
      if (this.$refs) {
        for (const key in this.$refs) {
          if (Array.isArray(this.$refs[key]) && this.$refs[key].length > 0) {
            for (let i = 0; i < this.$refs[key].length; i++) {
              if (
                this.$refs[key] &&
                this.$refs[key][i] &&
                this.$refs[key][i].onForceUpdate
              ) {
                this.$refs[key][i].onForceUpdate()
              } else if (
                this.$refs[key] &&
                this.$refs[key][i] &&
                this.$refs[key][i].$forceUpdate
              ) {
                this.$refs[key][i].$forceUpdate()
              }
            }
          } else if (!Array.isArray(this.$refs[key])) {
            if (this.$refs[key] && this.$refs[key].onForceUpdate) {
              this.$refs[key].onForceUpdate()
            } else if (this.$refs[key] && this.$refs[key].$forceUpdate) {
              this.$refs[key].$forceUpdate()
            }
          }
        }
      }
    },
    initAdditionalFieldData(row, additionalFieldInfoData) {
      if (!row.additionalFieldData) {
        row.additionalFieldData = {}
      }
      const infoData = row.additionalFieldData
      for (
        let i = 0;
        i < additionalFieldInfoData.additionalFieldInfos.length;
        i++
      ) {
        const info = additionalFieldInfoData.additionalFieldInfos[i]
        const ownerModel = info.ownerModel
        if (!infoData[ownerModel]) {
          infoData[ownerModel] = {}
        }
      }
    },
    initAdditionalFieldSampleData(row, additionalFieldInfoSampleData) {
      if (!row.additionalFieldData) {
        row.additionalFieldData = {}
      }
      const infoData = row.additionalFieldData
      for (
        let i = 0;
        i < additionalFieldInfoSampleData.additionalFieldInfos.length;
        i++
      ) {
        const info = additionalFieldInfoSampleData.additionalFieldInfos[i]
        const ownerModel = info.ownerModel
        if (!infoData[ownerModel]) {
          infoData[ownerModel] = {}
        }
      }
    },
    isImagePurpose(purpose) {
      return (
        purpose === 'file_purpose.thumb' ||
        purpose === 'file_purpose.image' ||
        purpose === 'file_purpose.result_inbody' ||
        purpose === 'file_purpose.begin_inbody' ||
        purpose === 'file_purpose.background_image' ||
        purpose.startsWith('file_purpose.image_') ||
        purpose.endsWith('_image')
      )
    },
    makeOptionText(option) {
      let text = ''
      if (!option.texts || option.texts.length === 0) {
        return option.value
      }
      for (let i = 0; i < option.texts.length; i++) {
        if (text) {
          text += ' - '
        }
        let textItem = ''
        if (
          option.texts[i].textPrefixes &&
          option.texts[i].textPrefixes.length > 0
        ) {
          for (let j = 0; j < option.texts[i].textPrefixes.length; j++) {
            textItem += option.texts[i].textPrefixes[j]
          }
        }
        if (option.texts[i].multilanguage) {
          let code = ''
          if (
            option.texts[i].codePrefixes &&
            option.texts[i].codePrefixes.length > 0
          ) {
            for (let j = 0; j < option.texts[i].codePrefixes.length; j++) {
              const codePrefix = option.texts[i].codePrefixes[j]
              if (codePrefix.type === 'static_value') {
                code += codePrefix.staticValue
              } else if (codePrefix.type === 'other_column') {
                if (codePrefix.fieldName) {
                  const fields = codePrefix.fieldName.split('.')
                  let val = option.data
                  for (let k = 0; k < fields.length; k++) {
                    val = val[fields[k]]
                  }
                  code += val
                }
              }
            }
          }
          code += option.texts[i].value
          if (
            option.texts[i].codePostfixes &&
            option.texts[i].codePostfixes.length > 0
          ) {
            for (let j = 0; j < option.texts[i].codePostfixes.length; j++) {
              const codePostfix = option.texts[i].codePostfixes[j]
              if (codePostfix.type === 'static_value') {
                code += codePostfix.staticValue
              } else if (codePostfix.type === 'other_column') {
                if (codePostfix.fieldName) {
                  const fields = codePostfix.fieldName.split('.')
                  let val = option.data
                  for (let k = 0; k < fields.length; k++) {
                    val = val[fields[k]]
                  }
                  code += val
                }
              }
            }
          }
          textItem += this.$t(code)
        } else {
          textItem += option.texts[i].value
        }
        if (
          option.texts[i].textPostfixes &&
          option.texts[i].textPostfixes.length > 0
        ) {
          for (let j = 0; j < option.texts[i].textPostfixes.length; j++) {
            textItem += option.texts[i].textPostfixes[j]
          }
        }
        text += textItem
      }
      return text
    },
    getDefaultColumnNameCode(key) {
      let code = 'column.nm.'
      if (key.indexOf('.') > 0) {
        code += key.substring(key.indexOf('.') + 1)
      } else {
        code += key
      }
      return code
    },
    makeLabels(columns) {
      if (!columns) {
        return
      }

      for (let i = 0; i < columns.length; i++) {
        const column = columns[i]
        if (!column.common || !column.common.label) {
          column.label = this.getDefaultColumnNameCode(column.key.toSnakeCase())
        } else {
          column.label = column.common.label
        }
        column.label = this.$t(column.label)
        if (
          column.inputControl &&
          (column.inputControl.type === 'section' ||
            column.inputControl.type === 'section_list')
        ) {
          this.makeLabels(column.columns)
        }
      }
    },
    openMenu(menu) {
      this.$emit('open-menu', menu)
    },
    closeMenu() {
      this.$forceUpdate()
      this.$emit('close-menu')
    },
    getMenusByRootMenu(rootMenu, paramMenus) {
      let menus = paramMenus
      if (!menus) {
        menus = this.menus
      }
      let retMenus
      if (menus && menus.length > 0) {
        for (let i = 0; i < menus.length; i++) {
          const menu = menus[i]
          if (menu.menu === rootMenu) {
            return menu.children
          }
          if (menu.children) {
            retMenus = this.getMenusByRootMenu(rootMenu, menu.children)
            if (retMenus) {
              return retMenus
            }
          }
        }
      }
      // 반환된 것도 없고 재귀호출이 되지 않은 상태이면 [] 반환
      if (!retMenus && !paramMenus) {
        retMenus = []
      }
      return retMenus
    },
    getMenusByLocation(lc) {
      const menus = []
      if (this.menus && this.menus.length > 0) {
        for (let i = 0; i < this.menus.length; i++) {
          if (
            this.menus[i].menuDsplyLcs &&
            this.menus[i].menuDsplyLcs.length > 0
          ) {
            for (let j = 0; j < this.menus[i].menuDsplyLcs.length; j++) {
              const menuDsplyLc = this.menus[i].menuDsplyLcs[j].menuLcCode
              if (lc === menuDsplyLc) {
                if (this.menus[i].link) {
                  if (this.loggedInUser) {
                    if (
                      this.menus[i].link === '/login' ||
                      this.menus[i].link === 'login'
                    ) {
                      menus.push({
                        link: '/logout',
                        menu: 'logout',
                        sttusCode: 'menu_status.active'
                      })
                      continue
                    }
                  }
                }
                menus.push(this.menus[i])
              }
            }
          }
        }
      }
      return menus
    },
    getValueKey(column) {
      if (
        !column ||
        !column.inputControl ||
        !column.inputControl.candidate ||
        !column.inputControl.candidate.key
      ) {
        return 'id'
      }
      return column.inputControl.candidate.key
    },
    getSelectOptions(column) {
      if (
        !column ||
        !column.inputControl ||
        !column.inputControl.candidate ||
        !column.inputControl.candidate.options
      ) {
        return []
      }
      const options = []
      if (column.inputControl.type === 'select') {
        options.push({
          value: '',
          text:
            this.$t('column.nm.' + column.key.toSnakeCase()) +
            ' - ' +
            this.$t('common.placeholder.select'),
          data: undefined
        })
      }
      const conditions = column.inputControl.candidate.conditions
      for (let i = 0; i < column.inputControl.candidate.options.length; i++) {
        const optionData = column.inputControl.candidate.options[i].data
        let add = true
        for (let j = 0; j < conditions.length; j++) {
          const condition = conditions[j]
          if (condition.type === 'master_data') {
            add = false
            if (
              condition.targetOperator === 'equals' &&
              this.masterSelectedRow[condition.targetFieldName] ===
                condition.targetValue
            ) {
              if (
                condition.candidateOperator === 'equals' &&
                optionData[condition.candidateFieldName] ===
                  condition.candidateValue
              ) {
                add = true
              } else if (
                condition.candidateOperator === 'not_equals' &&
                optionData[condition.candidateFieldName] !==
                  condition.candidateValue
              ) {
                add = true
              }
            } else if (
              condition.targetOperator === 'not_equals' &&
              this.masterSelectedRow[condition.targetFieldName] !==
                condition.targetValue
            ) {
              if (
                condition.candidateOperator === 'equals' &&
                optionData[condition.candidateFieldName] ===
                  condition.candidateValue
              ) {
                add = true
              } else if (
                condition.candidateOperator === 'not_equals' &&
                optionData[condition.candidateFieldName] !==
                  condition.candidateValue
              ) {
                add = true
              }
            }
            if (add) break
          }
        }

        if (!add) {
          continue
        }
        const text = this.makeOptionText(
          column.inputControl.candidate.options[i]
        )
        const value = column.inputControl.candidate.options[i].value

        options.push({
          value: value,
          text: text,
          data: optionData
        })
      }
      return options
    },
    getSelectOptionsFromRawOptions: function(key, rawOptions, type) {
      if (!rawOptions) {
        return []
      }
      const options = []
      if (type === 'select') {
        options.push({
          value: '',
          text:
            this.$t('column.nm.' + key.toSnakeCase()) +
            ' - ' +
            this.$t('common.placeholder.select'),
          data: undefined
        })
      }
      for (let i = 0; i < rawOptions.length; i++) {
        const optionData = rawOptions[i].data
        const text = this.makeOptionText(rawOptions[i])
        const value = rawOptions[i].value

        options.push({
          value: value,
          text: text,
          data: optionData
        })
      }
      return options
    },
    getSearchSelectOptions: function(column) {
      if (
        !column.search ||
        !column.search.candidate ||
        !column.search.candidate.options
      ) {
        return []
      }
      const options = []
      if (column.search.type === 'select') {
        options.push({
          value: '',
          text:
            this.$t(this.getDefaultColumnNameCode(column.key.toSnakeCase())) +
            ' - ' +
            this.$t('common.placeholder.select'),
          data: undefined
        })
      }
      for (let i = 0; i < column.search.candidate.options.length; i++) {
        const text = this.makeOptionText(column.search.candidate.options[i])
        const value = column.search.candidate.options[i].value
        const optionData = column.search.candidate.options[i].data
        options.push({
          value: value,
          text: text,
          data: optionData
        })
      }
      return options
    }
  }
})

window._onKeyboardShown = function() {
  console.log('keyboard shown')
  $('body').addClass('ime-shown')
}

window._onKeyboardHidden = function() {
  console.log('keyboard hidden')
  $('body').removeClass('ime-shown')
}
